import React from 'react';
import { Warning2, InfoCircle } from 'iconsax-react';

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'بەڵێ', cancelText = 'نەخێر', type = 'danger' }) => {
    if (!isOpen) return null;

    const isDanger = type === 'danger';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-neutral-900/50 backdrop-blur-sm animate-fade-in">
            <div className="bg-primary-white dark:bg-neutral-800 rounded-xlarge shadow-elevated w-full max-w-sm p-6 transform transition-all scale-100 animate-scale-in">
                <div className="flex flex-col items-center text-center">
                    <div className={`p-4 rounded-full mb-4 ${isDanger ? 'bg-error/10 text-error' : 'bg-info/10 text-info'}`}>
                        {isDanger ? <Warning2 size={48} variant="Bold" /> : <InfoCircle size={48} variant="Bold" />}
                    </div>

                    <h3 className="text-h4 font-bold text-neutral-800 dark:text-white mb-2">
                        {title}
                    </h3>

                    <p className="text-body-medium text-neutral-600 dark:text-neutral-400 mb-8">
                        {message}
                    </p>

                    <div className="flex gap-4 w-full">
                        <button
                            onClick={onCancel}
                            className="flex-1 py-3 px-4 rounded-medium border border-neutral-200 text-neutral-600 font-medium hover:bg-neutral-50 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-700 transition-colors"
                        >
                            {cancelText}
                        </button>
                        <button
                            onClick={onConfirm}
                            className={`flex-1 py-3 px-4 rounded-medium text-white font-bold shadow-button transition-colors ${isDanger
                                ? 'bg-error hover:bg-red-600'
                                : 'bg-primary-red hover:bg-blue-600'
                                }`}
                        >
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
